import { Button } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Layout3 from "../../../components/Layout/Layout3";
import Loading from "../../../components/Loading";
import { ModalInput, ModalSelect3 } from "../../../components/Modal";
import CustomSelect from "../../../components/Select";
import {
  getAllCustomers,
  getInvoiceNo,
  isGstInvoiceNumberValid,
  submitInvoiceDetail,
} from "../../../utils/api";
import useStore from "../../../utils/store";

const MarkInvoices = () => {
  const [loading, setLoading] = React.useState(false);
  const [newPayment, setNewPayment] = React.useState({});
  const user = useStore((state) => state.user);
  const [customers, setCustomers] = React.useState([]);
  var label;
  const [orderIds, setOrderIds] = React.useState(null);
  const [invoiceLoading, setInvoiceLoading] = React.useState(false);

  const [customerId, setCustomerId] = React.useState("");
  const [invoiceNo, setInvoiceNo] = React.useState("");
  const [productList, setProductList] = React.useState([]);
  const [invoiceDate, setInvoiceDate] = React.useState(null);
  const [invoiceData, setInvoiceData] = React.useState(null);
  const router = useNavigate();
  const getAllCustomerHandler = async () => {
    setLoading(true);
    const [success, data] = await getAllCustomers();
    if (success) {
      setCustomers(
        data.map((item) => ({
          ...item,
          name: `${item.userName} ${
            item?.group?.name !== undefined ? `(${item?.group?.name})` : ""
          }`,
        }))
      );
    }
    setLoading(false);
  };
  const [product, setProduct] = React.useState(null);
  const invoiceNoHandler = async (customerId) => {
    setInvoiceLoading(true);
    const [success, data] = await getInvoiceNo({
      customerId: customerId,
    });
    if (success) {
      setInvoiceNo(data.invoiceNumberString);
      setProductList(data.products);
    }
    setInvoiceLoading(false);
  };

  const createInvoicePayload = () => {
    return {
      ...invoiceData,
      invoiceNumberString: invoiceNo,
      customerId: customerId,
      orderIds: orderIds,
      ...(invoiceData?.quantity && { quantity: invoiceData?.quantity }),
    };
  };

  const invoiceHandler = async (isPrint = false, isWhatsApp = false) => {
    if (!customerId) {
      toast.error("Please select a customer first");
      return;
    }

    const [success2, data2] = await isGstInvoiceNumberValid(customerId);
    if (success2 && !data2?.isGst) {
      toast.error("Gst Invoice Number is not valid");
      return;
    }

    const valid =
      invoiceData?.quantity &&
      invoiceData?.quantity > 0 &&
      invoiceData?.quantity <=
        productList?.find((item) => item._id === product)?.quantity;

    if (!valid) {
      toast.error(
        `Please enter quantity less than ${
          productList?.find((item) => item._id === product)?.quantity
        } or enter quantity`
      );
      return;
    }
    setLoading(true);
    const endpoint = "/admin/invoice-partial";
    const payload = createInvoicePayload();

    const [success, data] = await submitInvoiceDetail(payload, endpoint);

    if (success) {
      setInvoiceData({});
      toast.success("Invoice Created successfully");
      if (isPrint) {
        if (isWhatsApp) {
          window.open(`/admin/invoice/${data._id}`, "_blank");
        } else {
          window.open(`/admin/invoice/${data._id}?type=white`, "_blank");
        }
      } else {
        getAllCustomerHandler();
        window.dispatchEvent(new Event("plabel-data-updated"));
        localStorage.setItem("plabel_last_sync", Date.now().toString());
      }
    } else {
      toast.error(data?.response?.data?.message);
    }
    setLoading(false);
  };

  React.useEffect(() => {
    getAllCustomerHandler();
  }, []);

  return (
    <Layout3 title={user?.staff?.userName}>
      {loading && <Loading />}

      <div className="flex md:items-center justify-center gap-3 md:flex-row flex-col bg-white py-10 px-10">
        <div className="flex flex-col gap-2">
          <div className="bg-secondary border-2 border-black px-2 py-1">
            Customer
          </div>
          <CustomSelect
            onChange={(e) => {
              setCustomerId(e.target.value);
              invoiceNoHandler(e.target.value);
              // Default invoice date to today when customer is selected
              const today = new Date();
              const todayStr = `${today.getFullYear()}-${String(
                today.getMonth() + 1
              ).padStart(2, "0")}-${String(today.getDate()).padStart(2, "0")}`;
              setInvoiceDate(todayStr);
              setInvoiceData((prev) => ({
                ...prev,
                invoiceDate: todayStr + "T13:40:31.520Z",
              }));
            }}
            options={customers
              .filter((item) => item?.type === "Customer")
              .map((customer) => ({
                value: customer._id,
                label: `${customer.userName} (${customer?.group?.name})`,
              }))}
            value={customerId}
          />
        </div>
        <div className="flex flex-col gap-2">
          <div className="bg-secondary border-2 whitespace-nowrap border-black px-2 py-1">
            Invoice Number
          </div>
          <ModalInput width={"w-full"} value={invoiceNo} disabled />
        </div>
        <div className="flex flex-col gap-2">
          <div className="bg-secondary border-2 border-black px-2 py-1">
            Date Pick
          </div>
          <ModalInput
            width={"w-full"}
            onChange={(e) => {
              setInvoiceDate(e.target.value);
              var result = e.target.value + "T13:40:31.520Z";
              setInvoiceData({
                ...invoiceData,
                invoiceDate: result,
              });
            }}
            value={invoiceDate}
            type="date"
          />
        </div>
        <div className="flex flex-col gap-2">
          <div className="bg-secondary border-2 border-black px-2 py-1">
            Products
          </div>

          <ModalSelect3
            title=""
            options={productList?.map((item) => ({
              label: `${item.name} (${item.quantity})`,
              value: item._id,
            }))}
            onChange={(e) => {
              setOrderIds(
                productList?.find((item) => item._id === e.target.value)
                  ?.orderIds
              );
              setProduct(e.target.value);
            }}
          />
        </div>

        <div className="flex flex-col gap-2">
          <div className="bg-secondary border-2 whitespace-nowrap border-black px-2 py-1">
            Quantity
          </div>
          <ModalInput
            width={"w-full"}
            onChange={(e) => {
              setInvoiceData({ ...invoiceData, quantity: e.target.value });
            }}
            value={invoiceData?.quantity || ""}
          />
        </div>
        <div className="flex flex-col gap-2">
          <div className="bg-secondary border-2 whitespace-nowrap border-black px-2 py-1">
            Note
          </div>
          <ModalInput
            width={"w-full"}
            onChange={(e) => {
              setInvoiceData({ ...invoiceData, note: e.target.value });
            }}
            value={invoiceData?.note || ""}
          />
        </div>

        <div className="flex flex-col gap-6">
          <Button
            variant="contained"
            color="primary"
            onClick={() => invoiceHandler(true, true)}
            disabled={invoiceLoading}
          >
            {invoiceLoading ? "Loading..." : "WhatsApp"}
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={() => invoiceHandler(true, false)}
            disabled={invoiceLoading}
          >
            {invoiceLoading ? "Loading..." : "Print"}
          </Button>
          {/* <Button variant="contained" color="primary" onClick={invoiceHandler}>
            {invoiceLoading ? "Loading..." : "Save"}
          </Button> */}
        </div>
      </div>
    </Layout3>
  );
};

export default MarkInvoices;
